import React, { useLayoutEffect, useState } from 'react'
import { useHistory, useParams, Link, Redirect } from 'react-router-dom'

import { EditTopic as EditTopicForm } from '../components/Topics'

import { useAsyncError } from '../components/error-handling'
import { getConfirmDelete } from '../components/specialized-components'
import { Loader } from '../components/ui-blocks'

import { useModal } from '../contexts'

import { getParsedFormData } from '../helpers'
import { getTopic, createTopic, updateTopic, deleteTopic } from '../helpers/consultdex-wp-api'


export const EditTopic = () => {
  const id = Number(useParams().id)

  const [topic, setTopic] = useState(null)
  const { openModal } = useModal()
  const history = useHistory()

  const handleAsyncError = useAsyncError()


  useLayoutEffect(() => {
    if (!id) {
      setTopic({})
      return
    }

    getTopic(id)
      .then(results => {
        setTopic(results)
      }, handleAsyncError)
  }, [id, handleAsyncError])


  const handleUpdate = async values => {
    if (topic?.id) {
      setTopic(await updateTopic(topic?.id, getParsedFormData(values)))
      return
    }

    const createdTopic = await createTopic(getParsedFormData(values))
    setTopic(createdTopic)
  }


  if (topic?.id && (id !== topic.id)) {
    return (<Redirect to={`/topics/${topic.id}`} />)
  }


  const handleDelete = async () => {
    if (await openModal(
      getConfirmDelete(<>You will delete the topic <strong>{topic.title}</strong>.</>)
    )) {
      await deleteTopic(topic.id)

      history.push('/topics/')
    }
  }


  return (
    <>
      <Link to="/topics/" className="text-dark mb-3 d-inline-block">Back to Topics</Link>
      {topic ?
        <EditTopicForm
          topic={topic}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
        />
        : <Loader fullWidth />
      }
    </>
  )

}
